import { Alert, Slide, Snackbar } from "@mui/material";
import { useSnackbars } from "../../store/snackbars/hooks";
import { RESPONSE_STATUS } from "../../pages/app/utils/constants";

export const AlignClipsSnackbarDL = () => {
  const {
    showAlignClipsSnackbarDL,
    alignClipsResponseDL,
    closeAlignClipsSnackbarDL,
    clearAlignClipsResponseDL,
  } = useSnackbars();

  const { status } = alignClipsResponseDL;
  const alertSeverity =
    RESPONSE_STATUS[status] === "success" ? "info" : "warning";

  const displayedMessage =
    RESPONSE_STATUS[status] === "success"
      ? "Clips queued for alignment."
      : "Clips cannot be aligned. Please try again.";

  const handleClose = () => closeAlignClipsSnackbarDL();
  const handleExited = () => clearAlignClipsResponseDL();

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      open={showAlignClipsSnackbarDL}
      autoHideDuration={5000}
      onClose={handleClose}
      slots={{
        transition: Slide,
      }}
      slotProps={{
        transition: {
          direction: "up",
          onExited: handleExited,
        },
      }}
      sx={{
        "&.MuiSnackbar-root": { width: 370 },
      }}
    >
      <Alert
        onClose={handleClose}
        severity={alertSeverity}
        variant="outlined"
        sx={{
          bgcolor: "background.paper",
          boxShadow: 3,
          width: "100%",
        }}
      >
        {displayedMessage}
      </Alert>
    </Snackbar>
  );
};
